/* CRO: lightweight wishlist — localStorage, no app.
   - Heart toggles: any element with [data-cro-wishlist-toggle][data-handle]
   - Count badges:  any element with [data-cro-wishlist-count]
   - Grid renderer: #CroWishlistGrid (wishlist page) */
(function () {
  var KEY = 'sapphire_wishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    updateUI();
  }

  var Wishlist = {
    get: read,
    has: function (h) {
      return read().indexOf(h) !== -1;
    },
    toggle: function (h) {
      var list = read();
      var i = list.indexOf(h);
      if (i === -1) list.push(h);
      else list.splice(i, 1);
      write(list);
      return i === -1;
    },
    remove: function (h) {
      write(
        read().filter(function (x) {
          return x !== h;
        })
      );
    },
    count: function () {
      return read().length;
    },
  };
  window.CroWishlist = Wishlist;

  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'DKK';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function updateUI() {
    var count = Wishlist.count();
    document.querySelectorAll('[data-cro-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('[data-cro-wishlist-toggle]').forEach(function (btn) {
      var active = Wishlist.has(btn.dataset.handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = btn.querySelector('[data-cro-wishlist-label]');
      if (label) label.textContent = active ? btn.dataset.labelRemove || 'Saved' : btn.dataset.labelAdd || 'Add to wishlist';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cro-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    Wishlist.toggle(btn.dataset.handle);
  });

  /* ---- wishlist page grid ---- */
  function renderGrid() {
    var grid = document.getElementById('CroWishlistGrid');
    if (!grid) return;
    var empty = document.getElementById('CroWishlistEmpty');
    var handles = read();
    grid.innerHTML = '';
    if (empty) empty.hidden = handles.length > 0;
    if (!handles.length) return;

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('gone');
          return r.json();
        })
        .then(function (p) {
          var li = document.createElement('li');
          li.className = 'cro-wishlist__item';
          var img = p.featured_image
            ? '<img src="' + p.featured_image + '&width=500" onerror="this.src=\'' + p.featured_image + '\'" alt="" loading="lazy">'
            : '';
          var price =
            p.compare_at_price && p.compare_at_price > p.price
              ? '<s>' + formatMoney(p.compare_at_price) + '</s> <span class="cro-wishlist__sale">' + formatMoney(p.price) + '</span>'
              : formatMoney(p.price);
          li.innerHTML =
            '<a class="cro-wishlist__link" href="' + p.url + '">' +
            '<div class="cro-wishlist__media">' + img + '</div>' +
            '<span class="cro-wishlist__title"></span>' +
            '<span class="cro-wishlist__price">' + price + '</span>' +
            '</a>' +
            '<button type="button" class="cro-wishlist__remove" aria-label="Remove from wishlist">Remove</button>';
          li.querySelector('.cro-wishlist__title').textContent = p.title;
          li.querySelector('.cro-wishlist__remove').addEventListener('click', function () {
            Wishlist.remove(handle);
            renderGrid();
          });
          grid.appendChild(li);
        })
        .catch(function () {
          /* product no longer published — drop it silently */
          Wishlist.remove(handle);
        });
    });
  }

  function init() {
    updateUI();
    renderGrid();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
